import {css, StyleSheet} from 'aphrodite';
import $ from 'jquery';
import React from 'react';

import DoDBanner from 'onboarding/banners/DoDBanner';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';
import * as logging from 'util/Logging';
import {InputChangeEvent} from 'util/Types';

import GenentechPTDBanner from './banners/GenentechPTDBanner';

export enum ClientBanners {
  DoD = 'DoD',
  GenentechPTD = 'GenentechPTD',
}

export function BannerCheckbox({
  labelText,
  isChecked,
  setIsChecked,
}: {
  labelText: string;
  isChecked: boolean;
  setIsChecked: (checked: boolean) => void;
}): JSX.Element {
  return (
    <>
      <input
        checked={isChecked}
        id="banner-checkbox"
        onChange={(e: InputChangeEvent) => {
          setIsChecked(e.target.checked);
        }}
        type="checkbox"
      />
      <FieldLabel htmlFor="banner-checkbox" className={css(styles.checkboxLabel)} label={labelText} />
    </>
  );
}

export default function ClientBanner(props: {
  bannerKey: ClientBanners;
  showRequiredCheckbox: boolean;
}): JSX.Element | null {
  const [isChecked, setIsChecked] = React.useState(false);
  function handleChangeCheckbox(newIsChecked: boolean): void {
    $('#has_acknowledged_banner').val(newIsChecked ? 'true' : 'false');
    setIsChecked(newIsChecked);
  }

  switch (props.bannerKey) {
    case ClientBanners.DoD:
      return (
        <div className={css(styles.bannerWrapper)}>
          <DoDBanner
            showRequiredCheckbox={props.showRequiredCheckbox}
            isChecked={isChecked}
            setIsChecked={handleChangeCheckbox}
          />
        </div>
      );
    case ClientBanners.GenentechPTD:
      return (
        <div className={css(styles.bannerWrapper)}>
          <GenentechPTDBanner
            showRequiredCheckbox={props.showRequiredCheckbox}
            isChecked={isChecked}
            setIsChecked={handleChangeCheckbox}
          />
        </div>
      );
    default:
      logging.warn(`Failed to find client banner: ${props.bannerKey}`);
      return null;
  }
}

export const CLIENT_BANNER_MODAL_KEY = 'client-banner-modal';
const BANNER_COMPONENTS = {
  [ClientBanners.DoD]: DoDBanner,
  [ClientBanners.GenentechPTD]: GenentechPTDBanner,
};

export function ClientBannerModal(props: {
  bannerKey: ClientBanners;
  showRequiredCheckbox: boolean;
}): JSX.Element {
  const [isAcknowledged, setIsAcknowledged] = React.useState(false);
  React.useEffect(() => {
    $('#has_acknowledged_banner').val(isAcknowledged ? 'true' : 'false');
  }, [isAcknowledged]);
  const BannerComponent = BANNER_COMPONENTS[props.bannerKey];
  return (
    <Modal
      closeable={false}
      large={true}
      suppressHeader={true}
      onRequestClose={() => {
        ModalContainer.close(CLIENT_BANNER_MODAL_KEY);
      }}
      buttons={[
        {
          text: 'Continue',
          cancel: true,
          disabled: !isAcknowledged && props.showRequiredCheckbox,
        },
      ]}
    >
      <BannerComponent
        showRequiredCheckbox={props.showRequiredCheckbox}
        isChecked={isAcknowledged}
        setIsChecked={setIsAcknowledged}
      />
    </Modal>
  );
}

const styles = StyleSheet.create({
  bannerWrapper: {
    marginTop: 80,
    marginBottom: 10,
  },
  checkboxLabel: {
    fontSize: 15,
    fontWeight: 'bold',
    marginLeft: '6px',
  },
});
